import React from 'react';

function Logo({logoPath}) {
  return (
    <div className="logo_wrap">
      <div className="logo">
        <img src={logoPath} alt="logo" />
      </div>
    </div>
  );
}

export default Logo;